<template>
  <v-expansion-panels>
    <a-expansion-panel v-for="(item, i) in 5" :key="i">
      <v-expansion-panel-header> Item </v-expansion-panel-header>
      <v-expansion-panel-content>
        Descriptionが入ります。最大3000文字。
        この文章はダミーです。文字の大きさ、量、字間、行間等を確認するために入れています。この文章はダミーです。文字の大きさ、量、字間、行間等を確認するために入れています。この文章はダミーです。文字の大きさ、量、字間、行間等を確認するために入れています。この文章はダミーです。文字の大きさ、量、字間、行間等を確認するために入れています。この文章はダミーです。文字の大きさ、量、字間、行間等を確認するために入れ
      </v-expansion-panel-content>
    </a-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import AExpansionPanel from "./AExpansionPanel.vue";
export default {
  components: { AExpansionPanel },
  name: "ExpansionSample",
};
</script>

<style>
</style>